import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='investment-advisory-services'
      headingText={<>Put our investment advisory services to work <WidowBlock>for you.</WidowBlock></>}
      text='Our financial advisors can recommend appropriate investment strategies and provide ongoing portfolio oversight to help you grow your wealth.'
    />
  );
};
